<template>
  <div class="flex items-center justify-center min-h-screen bg-gradient-to-br from-green-100 via-white to-blue-100 p-4">
    <div class="bg-white bg-opacity-90 shadow-xl rounded-2xl p-8 flex flex-col items-center text-center max-w-md w-auto">
      <img
          src="../../assets/images/Payment/payment-fail.png"
          class="w-20 h-20 mb-6"
      />
      <h1 class="text-xl font-semibold text-gray-800 mb-6">
        Ödemeniz alınamadı.
      </h1>
      <button type="submit" class="btn btn-success mt-3" @click.prevent="routeOrder">
        Bakiye Yükle
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "PaymentFail",
  mounted() {
    this.$store.commit('clearPendingOrder');
  },
  methods: {
    async routeOrder() {
      await this.$router.push({ name: 'Balance' });
    },
  },
};
</script>
